import {
  DefaultPage,
  CreateDeploymentSetting,
  UpdateDeploymentSetting,
  CodeExport,
  BetaCodeExport,
  CodeEditor,
  DatabaseDumpExport,
  GithubExport,
} from './';

export default {
  path: 'deployment-setting/:version/v',
  name: 'Deployment setting',
  childRoutes: [
    { path: ':projectId', name: 'Deployment Setting', component: DefaultPage, isPrivate: true },
    {
      path: ':projectId/create',
      name: 'Create deployment setting',
      component: CreateDeploymentSetting,
      isPrivate: true,
    },
    {
      path: ':projectId/update/:settingId',
      name: 'Update deployment setting',
      component: UpdateDeploymentSetting,
      isPrivate: true,
    },
    {
      path: ':projectId/code-export',
      name: 'Code export',
      component: CodeExport,
      isPrivate: true,
    },
    {
      path: ':projectId/code-export/beta',
      name: 'Beta code export',
      component: BetaCodeExport,
      isPrivate: true,
    },
    { path: ':projectId/code-ui', name: 'Code editor', component: CodeEditor, isPrivate: true },
    {
      path: ':projectId/dump-export',
      name: 'Database dump export',
      component: DatabaseDumpExport,
      isPrivate: true,
    },
    {
      path: ':projectId/github-export',
      name: 'Github export',
      component: GithubExport,
      isPrivate: true,
    },
  ],
};
